import request from "@/router/axios";

export const getBillTotalSummary = (start, end) => {
  return request({
    url: `/api/jc/bill/getBillTotalSummary`,
    method: "get",
    params: {
      start,
      end,
    },
  });
};
export const getBillTotalTrend = (start, end, hosId) => {
  return request({
    url: `/api/jc/bill/getBillTotalTrend`,
    method: "get",
    params: {
      start,
      end,
      hosId,
    },
  });
};
export const getExeDeptSummary = (start, end) => {
  return request({
    url: `/api/jc/bill/getExeDeptSummary`,
    method: "get",
    params: {
      start,
      end,
    },
  });
};
export const getExeDeptTrend = (start, end, exeDeptId) => {
  return request({
    url: `/api/jc/bill/getExeDeptTrend`,
    method: "get",
    params: {
      start,
      end,
      exeDeptId,
    },
  });
};
export const getBillDeptSummary = (start, end,resId) => {
  return request({
    url: `/api/jc/bill/getBillDeptSummary`,
    method: "get",
    params: {
      start,
      end,
      resId
    },
  });
};
export const getBillDeptTrend = (start, end, billDeptId) => {
  return request({
    url: `/api/jc/bill/getBillDeptTrend`,
    method: "get",
    params: {
      start,
      end,
      billDeptId,
    },
  });
};
export const getResourceSummary = (start, end,resId) => {
  return request({
    url: `/api/jc/bill/getResourceSummary`,
    method: "get",
    params: {
      start,
      end,
      resId
    },
  });
};
export const getResourceTrend = (start, end, resId) => {
  return request({
    url: `/api/jc/bill/getResourceTrend`,
    method: "get",
    params: {
      start,
      end,
      resId,
    },
  });
};
